module.exports = __webpack_public_path__ + "static/media/Ellipsis.e4814be9.svg";